export interface IBillingTransplantGroup {
      all: boolean,
      completed: boolean,
      pending: boolean
}
